export interface ISpecialItem {
	code: number;
	name: string;
	itemType: string;
	specialItemType: string;
	itemGrade: string;
	craftAnimTrigger: string;
	stackable: number;
	initialCount: number;
	makeMaterial1: number;
	makeMaterial2: number;
	consumeCount: number;
	summonCode: number;
}
